var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class AspectEventTypes {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspectEvent() {
        return this.parent;
    }
    get aspect() {
        return this.aspectEvent.aspect;
    }
    get eventsOfType() {
        return createTransformer(this.aspectEvent.observedEvents.observeEventType, this.aspectEvent.observedEvents.cleanupObservedEventType);
    }
}
__decorate([
    memoize
], AspectEventTypes.prototype, "eventsOfType", null);
